import { render, staticRenderFns } from "./StartConfig.vue?vue&type=template&id=18bc792c&"
import script from "./StartConfig.vue?vue&type=script&lang=js&"
export * from "./StartConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports